import React, { useEffect, useRef, useState } from "react";
import { FaCheck, FaPlus, FaRegFilePdf, FaSave } from "react-icons/fa";
import { HiOutlineRefresh } from "react-icons/hi";
import { IoMail, IoPrint } from "react-icons/io5";
import { LuView } from "react-icons/lu";
import { MdClose, MdEdit } from "react-icons/md";
import { RiCloseLargeFill } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import A1 from "../../Images/logo-w.png";
import axios from "axios";
import Select from "react-select";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { pdf } from "@react-pdf/renderer";
// import ReactPDF, { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFDownloadLink,
} from "@react-pdf/renderer";

import {
  Container,
  Row,
  Col,
  Form,
  Button,
  ListGroup,
  Card,
  Table,
} from "react-bootstrap";
import "./POvsMR.css";
import Modal from "react-modal";
import { saveAs } from "file-saver";
import { toWords } from "number-to-words";
import { BsFilePdf } from "react-icons/bs";

import Swal from "sweetalert2"; // For the popup

const POvsSupplier = () => {
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const user = JSON.parse(sessionStorage.getItem("user"));
  const id = user ? user.id : null;

  const [currentDate, setCurrentDate] = useState("");

  useEffect(() => {
    const date = new Date();
    const formattedDate = date.toISOString().split("T")[0];
    setCurrentDate(formattedDate);
  }, []);

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const [formMode, setFormMode] = useState("");
  // const userPermissions = user ? {
  //     add: user.add_permission,
  //     edit: user.edit_permission,
  //     view: user.view_permission,
  //     save: user.save_permission,
  //     approve: user.approve_permission,
  //     print: user.print_permission,
  //     close: user.close_permission,
  //     clear: user.clear_screen_permission
  // } : {};
  const userPermissions =
    user && user.permissions && user.permissions[3000]
      ? {
          add:
            user.permissions[3000].sub_ids[3003]?.permissions.add_permission ||
            0,
          edit:
            user.permissions[3000].sub_ids[3003]?.permissions.edit_permission ||
            0,
          view:
            user.permissions[3000].sub_ids[3003]?.permissions.view_permission ||
            0,
          save:
            user.permissions[3000].sub_ids[3003]?.permissions.save_permission ||
            0,
          approve:
            user.permissions[3000].sub_ids[3003]?.permissions
              .approve_permission || 0,
          print:
            user.permissions[3000].sub_ids[3003]?.permissions
              .print_permission || 0,
          close:
            user.permissions[3000].sub_ids[3003]?.permissions.exit_permission ||
            0,
          clear:
            user.permissions[3000].sub_ids[3003]?.permissions
              .refresh_permission || 0,
        }
      : {};

  const getButtonState = (permissionType) => {
    switch (formMode) {
      case "create":
        return (
          permissionType === "create" ||
          permissionType === "clear" ||
          permissionType === "save" ||
          permissionType === "close"
        );
      case "edit":
        return (
          permissionType === "edit" ||
          permissionType === "clear" ||
          permissionType === "save" ||
          permissionType === "close"
        );
      case "view":
        return (
          permissionType === "view" ||
          permissionType === "clear" ||
          permissionType === "close"
        );
      case "approve":
        return (
          permissionType === "clear" ||
          permissionType === "view" ||
          permissionType === "approve" ||
          permissionType === "print" ||
          permissionType === "close"
        );
      default:
        return false;
    }
  };

  const [items, setItems] = useState([]);
  const [indents, setIndents] = useState([]);
  const [combinedData, setCombinedData] = useState([]);
  const [ALLData, setAllData] = useState([]);
  const [selectedData, setSelectedData] = useState(null); // State for dropdown selection

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  // Function to format date to YYYY-MM-DD
  const formatDateToDateInput = (date) => {
    const dateObj = new Date(date);
    const year = dateObj.getFullYear();
    const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
    const day = dateObj.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const [poList, setPoList] = useState([""]);

  const [supplierList, setSupplierList] = useState([]); // Supplier data

  const [supplierFilter, setSupplierFilter] = useState(null);

  const getSupplierName = (supp_id) => {
    const supplier = supplierList.find((s) => s.Supp_cd === supp_id);
    return supplier ? supplier.Supp_Nm : "Unknown Supplier"; // Return supplier name or 'Unknown Supplier' if not found
  };

  useEffect(() => {
    const fetchPOData = async () => {
      try {
        // Fetch Purchase Orders
        const poResponse = await axios.get(
          "https://erpapi.emedha.in/pages/api/poget/MatirialReceipt"
        );
        setPoList(poResponse.data);

        const suppResponse = await axios.get(
          "https://erpapi.emedha.in/pages/api/purSuppMst"
        ); // Replace with your actual API endpoint  https://erpapi.emedha.in
        setSupplierList(suppResponse.data); // Assuming this API returns an array of suppliers
      } catch (error) {
        console.error("Error fetching purchase orders or suppliers", error);
      }
    };

    fetchPOData();
  }, []);

  // Filter combinedData based on selected date range
  const filterByDateRange = (poList) => {
    if (!fromDate || !toDate) return [];
    const fromDateObj = new Date(fromDate);
    const toDateObj = new Date(toDate);
    fromDateObj.setHours(0, 0, 0, 0);
    toDateObj.setHours(23, 59, 59, 999);

    return poList.filter((item) => {
      const indentDate = new Date(item.PO_HDR.PO_Dt);
      return indentDate >= fromDateObj && indentDate <= toDateObj;
    });
  };

  const filteredALLData = filterByDateRange(poList);

  const [exportFormat, setExportFormat] = useState("pdf"); // Default is 'pdf'

  const handleExportFormatChange = (selectedOption) => {
    setExportFormat(selectedOption.value);
  };

  const handleExportToExcel = () => {
    // Ensure filteredALLData is defined and contains data
    const poList = filteredALLData;

    if (!poList || poList.length === 0) {
      console.error("No data available to export.");
      return;
    }

    // Prepare the worksheet data with a header row
    const wsData = [
      [
        "PO_NO",
        "Supplier CD",
        "Supplier Name",
        "PO_DT",
        "Item",
        "Item Desc",
        "UOM",
        "Quantity",
      ],
      ...poList.flatMap((item) => {
        const poHdr = item.PO_HDR || {};
        const poDtl = item.PO_DTL || []; // Ensure PO_DTL is an array

        // For each PO_DTL item, create a row
        return poDtl.map((poDtlItem) => [
          poHdr.PO_no || "", // PO_NO (fallback to empty if missing)
          poHdr.Supp_id || "", // Supplier CD
          getSupplierName(poHdr.Supp_id) || "", // Supplier Name
          formatDateToDateInput(poHdr.PO_Dt) || "", // PO_DT (ensure PO_Dt exists)
          poDtlItem.itemCd || "", // Item Code
          poDtlItem.itemDesc || "", // Item Description
          poDtlItem.UOM || "", // Unit of Measure
          poDtlItem.qty || "", // Quantity
        ]);
      }),
    ];

    // Log the worksheet data for debugging
    console.log("Worksheet Data:", wsData);

    // Create worksheet from array of arrays
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // Create a new workbook and append the worksheet to it
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Data");

    // Write the Excel file to disk
    XLSX.writeFile(wb, "table.xlsx");
  };

  const [states, setStates] = useState({});
  const [stateName, setStateName] = useState("");
  const [stateNamee, setStateNamee] = useState("");

  const [suppliers, setSuppliers] = useState([]);
  const [supplierName, setSupplierName] = useState("");

  const [supplierAdd, setSuppliersAddress] = useState("");

  const [supplierEmail, setSupplierEmail] = useState("");

  const [supplierPhoneNumber, setSupplierPhoneNumber] = useState("");
  const [PO_no, setPO_no] = useState("");

  const [Po_Tc, setPoTcData] = useState([]);

  const [poData, setPoData] = useState(null);
  const [pdfUrl, setPdfUrl] = useState("");

  const [poNumbers, setPoNumbers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filteredPoData, setFilteredPoData] = useState([]); // State for filtered data
  // Fetch available PO numbers on initial render

  const fetchPONumbers = async () => {
    try {
      const response = await axios.get(
        "https://erpapi.emedha.in/pages/api/api/po-numbers"
      );
      setPoNumbers(response.data);
    } catch (err) {
      console.error("Error fetching PO numbers", err);
    }
  };
  useEffect(() => {
    fetchPONumbers();
  }, []);

  // Fetch data for the selected PO_no when it changes

  const fetchPoData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `https://erpapi.emedha.in/pages/api/PURCHASE_ORDER/${PO_no}`
      );
      setPoData(response.data);
      setPdfUrl(response.data.PO_HDR.pdf_url);
    } catch (err) {
      console.error("Error fetching PO data", err);
      setError("Failed to fetch purchase order data");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!PO_no) return;

    fetchPoData();
  }, [PO_no]);
  // This effect runs whenever PO_no changes
  console.log(poData);
  useEffect(() => {
    const fetchPoTcData = async () => {
      try {
        const response = await axios.get(
          "https://erpapi.emedha.in/pages/api/api/get-po-data"
        );
        setPoTcData(response.data); // Set the fetched data to state
        setLoading(false); // Set loading to false when data is fetched
      } catch (err) {
        setError("Error fetching data"); // Set error if something goes wrong
        setLoading(false); // Set loading to false even on error
      }
    };

    fetchPoTcData();
  }, []);

  useEffect(() => {
    console.log("Po_Tc:", Po_Tc); // Log Po_Tc to verify the fetched data
    console.log("Selected PO_no:", PO_no); // Log PO_no to see what's selected

    if (Po_Tc.length > 0 && PO_no) {
      // Filter the data based on selected PO_no
      const filteredData = Po_Tc.filter(
        (item) => String(item.PO_no) === String(PO_no)
      );
      setFilteredPoData(filteredData); // Set filtered data to state
      console.log("Filtered Data:", filteredData); // Log the filtered data
    } else {
      setFilteredPoData([]); // Clear filtered data if no PO_no is selected or data is empty
    }
  }, [PO_no, Po_Tc]); // Run whenever PO_no or Po_Tc changes

  console.log("this is the PO No ", PO_no);
  console.log(filteredPoData);

  const latestPO = poNumbers.length > 0 ? Math.max(...poNumbers) : null;

  const poOptions = poNumbers.map((poNumber) => ({
    value: poNumber,
    label: poNumber,
  }));

  const handlePOSelectChange = (selectedOption) => {
    setPO_no(selectedOption ? selectedOption.value : "");
    setPoData(null); // Reset PO data when a new PO is selected
  };

  const fetchStateMaster = () => {
    axios
      .get("https://erpapi.emedha.in/pages/api/api/states")
      .then((response) => {
        setStates(response.data);
      })
      .catch((error) => {
        console.error("Error fetching state master:", error);
      });
  };
  useEffect(() => {
    fetchStateMaster();
  }, []);

  useEffect(() => {
    // Ensure PO data and states are loaded
    if (poData && poData.PO_HDR && states) {
      const stateCode = poData.PO_HDR.Supp_gst.slice(0, 2); // Extract first 2 characters (state code)
      const state = states[stateCode]; // Find the state by code
      if (state) {
        setStateName(state); // Set state name if found
      } else {
        setStateName("Unknown State"); // Default in case the state is not found
      }
    }
  }, [poData, states]);

  useEffect(() => {
    // Ensure PO data and states are loaded
    if (poData && poData.PO_HDR && states) {
      const stateCode = poData.PO_HDR.Des_state_cd; // Extract first 2 characters (state code)
      const state = states[stateCode]; // Find the state by code
      if (state) {
        setStateNamee(state); // Set state name if found
      } else {
        setStateNamee("Unknown State"); // Default in case the state is not found
      }
    }
  }, [poData, states]);

  // useEffect(() => {
  //     // When poData.PO_HDR.Supp_id changes, find the supplier name
  //     if (poData.PO_HDR.Supp_id) {
  //       const supplier = suppliers.find(sup => sup.Supp_cd === poData.PO_HDR.Supp_id);
  //       if (supplier) {
  //         setSupplierName(supplier.Supp_Nm); // Set the supplier name
  //       }
  //     }
  //   }, [poData, suppliers]);

  useEffect(() => {
    // Ensure poData and PO_HDR exist before accessing
    const suppId = poData?.PO_HDR?.Supp_id;

    if (suppId) {
      const supplier = suppliers.find((sup) => sup.Supp_cd === suppId);
      if (supplier) {
        setSupplierName(supplier.Supp_Nm); // Set the supplier name supplierEmail
        setSuppliersAddress(supplier.Supp_Address);
        setSupplierEmail(supplier.Contact_Person_Email);
        setSupplierPhoneNumber(supplier.Contact_Person_Ph);
      }
    }
  }, [poData, suppliers]);

  console.log(suppliers);
  console.log(supplierName);
  console.log(supplierAdd);
  console.log(supplierPhoneNumber);

  const fetchSuppliers = () => {
    axios
      .get("https://erpapi.emedha.in/pages/api/api/suppliers")
      .then((response) => {
        setSuppliers(response.data);
      })
      .catch((error) => {
        console.error("Error fetching suppliers:", error);
      });
  };

  useEffect(() => {
    fetchSuppliers();
  }, []);
  const [companyData, setCompanyData] = useState([]); // State to store fetched company data
  const [filteredCompanyData, setFilteredCompanyData] = useState(null);
  // useEffect(() => {
  //     const fetchCompanyData = async () => {
  //         try {
  //             const response = await axios.get('https://erpapi.emedha.in/pages/api/api/get-Company-data'); // Replace with your actual backend URL
  //             setCompanyData(response.data); // Set the fetched data to state
  //             setLoading(false); // Set loading to false after data is fetched
  //         } catch (err) {
  //             setError('Error fetching company data'); // Set error state if there's an error
  //             setLoading(false); // Set loading to false on error
  //         }
  //     };

  //     fetchCompanyData();
  // }, []);
  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        const response = await axios.get(
          "https://erpapi.emedha.in/pages/api/api/get-Company-data"
        );
        setCompanyData(response.data); // Set company data to state
        setLoading(false);
      } catch (err) {
        setError("Error fetching company data");
        setLoading(false);
      }
    };

    fetchCompanyData();
  }, []);

  // Filter company data based on matching GST_NO
  useEffect(() => {
    console.log("Company Data:", companyData); // Check what company data looks like
    console.log("PO Data:", poData); // Check PO data to see if it contains Supp_gst
    if (poData && companyData.length > 0) {
      const match = companyData.find(
        (company) => company.GST_NO === poData.PO_HDR.Des_gst
      );
      console.log("Match Found:", match); // Check if the match is found
      if (match) {
        setFilteredCompanyData(match); // Set filtered company data
      } else {
        setFilteredCompanyData(null); // No match found
      }
    }
  }, [poData, companyData]); // This effect runs when PO data or company data changes

  console.log("filteredCompanyData", filteredCompanyData);

  const styles = StyleSheet.create({
    page: {
      padding: 20,
      fontSize: 8,
      border: "1px solid black", // Adding a border around the page
    },
    heading: {
      textAlign: "center",
      fontSize: 20,
      color: "blue",
      marginBottom: 20,
    },
    section: {
      display: "flex",
      flexDirection: "column",
      marginBottom: 16,
    },
    fieldWrapper: {
      display: "flex",
      flexDirection: "row",
      marginBottom: 8,
    },
    label: {
      color: "darkblue",
      width: "40%",
    },
    input: {
      border: "none",
      borderLeft: "2px solid #D1D5DB",
      padding: 2,
      width: "60%",
      outline: "none",
      backgroundColor: "transparent",
      fontSize: 10,
    },
    table: {
      marginTop: 20,
      width: "100%",
      borderCollapse: "collapse",
    },
    tableHeader: {
      backgroundColor: "#ffffff",
      textAlign: "center",
      fontWeight: "bold",
      border: "1px solid black",
    },
    tableCell: {
      border: "1px solid black",
      textAlign: "center",
      padding: 2,
    },
    tableRow: {
      display: "flex",
      flexDirection: "row",
    },
  });

  const MyDocument = ({
    poData,
    stateNamee,
    stateName,
    supplierName,
    formatDateToDateInput,
  }) => (
    <Document>
      <Page style={styles.page}>
        <Text style={styles.heading}>PurchaseOrder VS MaterialReceipt</Text>
        {poData.PO_HDR.map((po) => (
          <View style={styles.section}>
            {/* PO Type */}
            <View style={styles.fieldWrapper}>
              <Text style={styles.label}>PO Type:</Text>
              <Text style={styles.input}>{po.Po_Type}</Text>
            </View>

            {/* Delivery Terms */}
            <View style={styles.fieldWrapper}>
              <Text style={styles.label}>Delivery Terms:</Text>
              <Text style={styles.input}>{po.Deli_terms}</Text>
            </View>

            {/* Delivery Date */}
            <View style={styles.fieldWrapper}>
              <Text style={styles.label}>Delivery Dt:</Text>
              <Text style={styles.input}>
                {formatDateToDateInput(po.Deli_dt)}
              </Text>
            </View>

            {/* Destination GST */}
            <View style={styles.fieldWrapper}>
              <Text style={styles.label}>Destination GST:</Text>
              <Text style={styles.input}>{po.Des_gst}</Text>
            </View>

            {/* Destination State */}
            <View style={styles.fieldWrapper}>
              <Text style={styles.label}>Destination State:</Text>
              <Text style={styles.input}>{stateNamee}</Text>
            </View>

            {/* PO Date */}
            <View style={styles.fieldWrapper}>
              <Text style={styles.label}>PO Dt:</Text>
              <Text style={styles.input}>
                {formatDateToDateInput(po.PO_Dt)}
              </Text>
            </View>

            {/* Item Type */}
            <View style={styles.fieldWrapper}>
              <Text style={styles.label}>Item Type:</Text>
              <Text style={styles.input}>{po.Item_type}</Text>
            </View>

            {/* Payment Terms */}
            <View style={styles.fieldWrapper}>
              <Text style={styles.label}>Payment Terms:</Text>
              <Text style={styles.input}>{po.Pay_terms}</Text>
            </View>

            {/* Supplier */}
            <View style={styles.fieldWrapper}>
              <Text style={styles.label}>Supplier:</Text>
              <Text style={styles.input}>{supplierName}</Text>
            </View>

            {/* Credit Days */}
            <View style={styles.fieldWrapper}>
              <Text style={styles.label}>Credit Days:</Text>
              <Text style={styles.input}>{po.Credit_days}</Text>
            </View>

            {/* Supplier GST */}
            <View style={styles.fieldWrapper}>
              <Text style={styles.label}>Supplier GST:</Text>
              <Text style={styles.input}>{po.Supp_gst}</Text>
            </View>

            {/* Supplier State */}
            <View style={styles.fieldWrapper}>
              <Text style={styles.label}>Supplier State:</Text>
              <Text style={styles.input}>{stateName}</Text>
            </View>
          </View>
        ))}
        {/* Table with vertical display of data */}
        <View style={styles.table}>
          <Text style={styles.tableHeader}>Purchase Order Details</Text>
          {poData.PO_DTL.map((indent, index) => (
            <View key={index} style={{ marginBottom: 10 }}>
              <Text style={{ fontWeight: "bold" }}>Item {index + 1}</Text>
              <View style={styles.fieldWrapper}>
                <Text style={styles.label}>Item Code:</Text>
                <Text style={styles.input}>{indent.itemCd}</Text>
              </View>
              <View style={styles.fieldWrapper}>
                <Text style={styles.label}>Item Description:</Text>
                <Text style={styles.input}>{indent.itemDesc}</Text>
              </View>
              <View style={styles.fieldWrapper}>
                <Text style={styles.label}>UOM:</Text>
                <Text style={styles.input}>{indent.UOM}</Text>
              </View>
              <View style={styles.fieldWrapper}>
                <Text style={styles.label}>HSN Code:</Text>
                <Text style={styles.input}>{indent.Hsn_code}</Text>
              </View>
              <View style={styles.fieldWrapper}>
                <Text style={styles.label}>GST %:</Text>
                <Text style={styles.input}>{indent.GST_per}</Text>
              </View>
              <View style={styles.fieldWrapper}>
                <Text style={styles.label}>Indent Location:</Text>
                <Text style={styles.input}>{indent.Indent_loc}</Text>
              </View>
              <View style={styles.fieldWrapper}>
                <Text style={styles.label}>Indent No:</Text>
                <Text style={styles.input}>{indent.Indent_no}</Text>
              </View>
              <View style={styles.fieldWrapper}>
                <Text style={styles.label}>Indent Qty:</Text>
                <Text style={styles.input}>{indent.qty}</Text>
              </View>
              <View style={styles.fieldWrapper}>
                <Text style={styles.label}>PO Qty:</Text>
                <Text style={styles.input}>{indent.PO_qty}</Text>
              </View>
              <View style={styles.fieldWrapper}>
                <Text style={styles.label}>Item Rate:</Text>
                <Text style={styles.input}>{indent.Item_rate}</Text>
              </View>
              <View style={styles.fieldWrapper}>
                <Text style={styles.label}>Gross Amt:</Text>
                <Text style={styles.input}>{indent.Gross_amt}</Text>
              </View>
              <View style={styles.fieldWrapper}>
                <Text style={styles.label}>Disc %:</Text>
                <Text style={styles.input}>{indent.Disc_per}</Text>
              </View>
              <View style={styles.fieldWrapper}>
                <Text style={styles.label}>Disc Amt:</Text>
                <Text style={styles.input}>{indent.Disc_amt}</Text>
              </View>
              <View style={styles.fieldWrapper}>
                <Text style={styles.label}>Taxable amt:</Text>
                <Text style={styles.input}>{indent.Taxable_amt}</Text>
              </View>
              <View style={styles.fieldWrapper}>
                <Text style={styles.label}>SGST %:</Text>
                <Text style={styles.input}>{indent.Sgst_per}</Text>
              </View>
              <View style={styles.fieldWrapper}>
                <Text style={styles.label}>SGST Amt:</Text>
                <Text style={styles.input}>{indent.Sgst_amt}</Text>
              </View>
              <View style={styles.fieldWrapper}>
                <Text style={styles.label}>CGST %:</Text>
                <Text style={styles.input}>{indent.Cgst_per}</Text>
              </View>
              <View style={styles.fieldWrapper}>
                <Text style={styles.label}>CGST Amt:</Text>
                <Text style={styles.input}>{indent.Cgst_amt}</Text>
              </View>
              <View style={styles.fieldWrapper}>
                <Text style={styles.label}>IGST %:</Text>
                <Text style={styles.input}>{indent.Igst_per}</Text>
              </View>
              <View style={styles.fieldWrapper}>
                <Text style={styles.label}>IGST Amt:</Text>
                <Text style={styles.input}>{indent.Igst_amt}</Text>
              </View>
              <View style={styles.fieldWrapper}>
                <Text style={styles.label}>UGST %:</Text>
                <Text style={styles.input}>{indent.Ugst_per}</Text>
              </View>
              <View style={styles.fieldWrapper}>
                <Text style={styles.label}>UGST Amt:</Text>
                <Text style={styles.input}>{indent.Ugst_amt}</Text>
              </View>
              <View style={styles.fieldWrapper}>
                <Text style={styles.label}>Net Amt:</Text>
                <Text style={styles.input}>{indent.Net_amt}</Text>
              </View>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );

  const amountInWords = toWords(poData?.PO_HDR?.Total_amt || 0);

  function formatDateToDDMMYYYY(date) {
    const d = new Date(date);
    const day = ("0" + d.getDate()).slice(-2); // Add leading zero if needed
    const month = ("0" + (d.getMonth() + 1)).slice(-2); // Add leading zero if needed
    const year = d.getFullYear();
    return `${day}-${month}-${year}`; // Format as DD-MM-YYYY
  }

  const [companyDataName, setCompanyDataName] = useState([]);
  const [companyDataGST, setCompanyDataGST] = useState([]);

  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        const response = await axios.get(
          "https://erpapi.emedha.in/pages/api/api/get-Company-data"
        );
        setCompanyDataName(response.data[0].name); // Set company data to state
        setCompanyDataGST(response.data[0].company_logo);
        setLoading(false);
      } catch (err) {
        setError("Error fetching company data");
        setLoading(false);
      }
    };

    fetchCompanyData();
  }, []);

  const generatePDF = () => {
    if (!PO_no) {
      // Show popup if PO No is not selected
      Swal.fire({
        title: "Please select a PO No",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    const doc = new jsPDF(); // Create a new PDF document

    // Set font for header info
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);

    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    doc.setLineWidth(1);
    doc.rect(0, 0, pageWidth, pageHeight); // Drawing the border

    doc.setFontSize(16); // Larger font size for the heading
    const heading = "Purchase Order";
    const headingWidth = doc.getTextWidth(heading); // Calculate the width of the heading
    // const pageWidth = doc.internal.pageSize.width;  // Get the page width
    const xPosition = (pageWidth - headingWidth) / 2; // Calculate X position to center the text
    doc.text(heading, xPosition, 20); // Adjust Y position to place it near the top

    // Set the font back to normal size after the heading
    doc.setFontSize(8);

    // PO Header Info with better layout
    let yPosition = 30; // Starting Y position for the header info

    // Adjust X positions for each field to get them in a row-like structure
    const col1X = 10; // PO Type, Delivery Terms, Delivery Date, etc.
    const col2X = 80; // PO Date, Item Type, Payment Terms, etc.
    const col3X = 150; // Supplier, Credit Days, Supplier GST, etc.

    const logoUrl = companyDataGST; // Path relative to the public folder
    const logoWidth = 50; // Width of the logo
    const logoHeight = 13; // Height of the logo

    // Add the image to the PDF in the top-left corner
    doc.addImage(logoUrl, "PNG", 10, 5, logoWidth, logoHeight);

    doc.text("TO", col1X, yPosition);

    yPosition += 5; // Move to next line

    doc.text("Supplier            : " + supplierName, col1X, yPosition);
    doc.text("PO NO               : " + PO_no, col2X, yPosition);

    yPosition += 5; // Move to the next line
    doc.text("Address            : " + supplierAdd, col1X, yPosition, {
      maxWidth: 65,
    });
    doc.text(
      "PO Date             : " + formatDateToDDMMYYYY(poData.PO_HDR.PO_Dt),
      col2X,
      yPosition
    );

    yPosition += 15; // Move to the next line
    doc.text(
      " GST                 : " + poData.PO_HDR.Supp_gst,
      col1X,
      yPosition
    );
    doc.text(
      "Delivery Terms   : " + poData.PO_HDR.Deli_terms,
      col2X,
      yPosition
    );

    yPosition += 5; // Move to the next line
    doc.text(" State                : " + stateName, col1X, yPosition);
    doc.text(
      "Delivery Date       : " + formatDateToDDMMYYYY(poData.PO_HDR.Deli_dt),
      col2X,
      yPosition
    );

    yPosition += 5; // Move to the next line
    doc.text("Payment Terms   : " + poData.PO_HDR.Pay_terms, col2X, yPosition);

    yPosition += 5; // Move to the next line

    doc.text("Currency   : " + poData.PO_HDR.currency, col2X, yPosition);

    yPosition += 5; // Move to the next line
    if (poData.PO_HDR.currency !== "INR") {
      doc.text(
        "Exchange Rate   : " + poData.PO_HDR.exchange_rate,
        col2X,
        yPosition
      );
    }
    yPosition += 5; // Move to the next line
    doc.text("Invoice To", col1X, yPosition);

    yPosition += 5; // Move to the next line
    doc.text(
      "                      " + filteredCompanyData.name,
      col1X,
      yPosition
    );
    yPosition += 5;
    doc.text(
      "                      " + filteredCompanyData.address,
      col1X,
      yPosition
    );
    yPosition += 5;
    doc.text(
      "                      " + filteredCompanyData.GST_NO,
      col1X,
      yPosition
    );

    let startY = yPosition + 10; // Starting Y position for the table

    // const headers = [
    //     "Sl", "Item Code", "Item Desc", "UOM", "HSN CODE",
    //     "PO Qty", "Item Rate",
    //     "Disc %", "Disc Amt", "Taxable amt","GrossAmt (FC)", "SGST %", "SGST AMT",
    //     "CGST %", "CGST Amt", "IGST %", "IGST Amt", "Net Amt"
    // ];

    // doc.setFontSize(8);

    // doc.autoTable({
    //     startY: startY,
    //     head: [headers],

    //     body: poData.PO_DTL.map((item, index) => {

    //         return [
    //             index + 1,
    //             item.itemCd,
    //             item.itemDesc,
    //             item.UOM,
    //             item.Hsn_code,
    //             item.PO_qty,
    //             item.Item_rate,
    //             item.Disc_per,
    //             item.Disc_amt,
    //             item.Taxable_amt,
    //             item.grpss_amt_fce,
    //             item.Sgst_per,
    //             item.Sgst_amt,
    //             item.Cgst_per,
    //             item.Cgst_amt,
    //             item.Igst_per,
    //             item.Igst_amt,
    //             item.Net_amt
    //         ];
    //     }),

    //     styles: {
    //         cellWidth: '25px',  // Adjust the cell width
    //         fontSize: 8,  // Set font size for the table content
    //         lineWidth: 0.5,  // Set line width for borders
    //         lineColor: [0, 0, 0],  // Set line color to black for borders
    //     },
    //     theme: 'grid',
    // });

    const isImport = poData.PO_HDR.Item_type === "Import"; // Check if Item_type is Import
    const isLocal = poData.PO_HDR.Item_type === "Local"; // Check if Item_type is Local

    let headers = [];
    let bodyData = [];

    if (isLocal) {
      headers = [
        "Sl",
        "Item Code",
        "Item Desc",
        "UOM",
        "HSN CODE",
        "PO Qty",
        "Item Rate",
        "Disc %",
        "Disc Amt",
        "Taxable amt",
        // "SGST %",
        // "SGST AMT",
        // "CGST %",
        // "CGST Amt",
        // "IGST %",
        // "IGST Amt",
        "Net Amt",
      ];

      bodyData = poData.PO_DTL.map((item, index) => [
        index + 1,
        item.itemCd,
        item.itemDesc,
        item.UOM,
        item.Hsn_code,
        item.PO_qty,
        item.Item_rate,
        item.Disc_per,
        item.Disc_amt,
        item.Taxable_amt,
        // item.Sgst_per,
        // item.Sgst_amt,
        // item.Cgst_per,
        // item.Cgst_amt,
        // item.Igst_per,
        // item.Igst_amt,
        item.Net_amt,
      ]);
    } else if (isImport) {
      headers = [
        "Sl",
        "Item Code",
        "Item Desc",
        "UOM",
        "HSN CODE",
        "PO Qty",
        "Item Rate",
        "Disc %",
        "Disc Amt",
        "Taxable amt",
        "GrossAmt (FC)",
      ];

      bodyData = poData.PO_DTL.map((item, index) => [
        index + 1,
        item.itemCd,
        item.itemDesc,
        item.UOM,
        item.Hsn_code,
        item.PO_qty,
        item.Item_rate,
        item.Disc_per,
        item.Disc_amt,
        item.Taxable_amt,
        item.grpss_amt_fce,
      ]);
    }

    doc.setFontSize(8);

    doc.autoTable({
      startY: startY,
      head: [headers],
      body: bodyData,
      styles: {
        cellWidth: "25px",
        fontSize: 8,
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
      },
      theme: "grid",
    });

    //////

    // const isImport = poData.PO_HDR.Item_type;

    // const headers = isImport
    //   ? [
    //       "Sl",
    //       "Item Code",
    //       "Item Desc",
    //       "UOM",
    //       "HSN CODE",
    //       "PO Qty",
    //       "Item Rate",
    //       "Disc %",
    //       "Disc Amt",
    //       "Taxable amt",
    //       "GrossAmt (FC)",
    //       "SGST %",
    //       "SGST AMT",
    //       "CGST %",
    //       "CGST Amt",
    //       "IGST %",
    //       "IGST Amt",
    //       "Net Amt",
    //     ]
    //   : [
    //       "Sl",
    //       "Item Code",
    //       "Item Desc",
    //       "UOM",
    //       "HSN CODE",
    //       "PO Qty",
    //       "Item Rate",
    //       "Disc %",
    //       "Disc Amt",
    //       "Taxable amt",
    //       "GrossAmt (FC)",
    //     ];

    // doc.setFontSize(8);

    // doc.autoTable({
    //   startY: startY,
    //   head: [headers],
    //   body: poData.PO_DTL.map((item, index) => {
    //     return isImport
    //       ? [
    //           index + 1,
    //           item.itemCd,
    //           item.itemDesc,
    //           item.UOM,
    //           item.Hsn_code,
    //           item.PO_qty,
    //           item.Item_rate,
    //           item.Disc_per,
    //           item.Disc_amt,
    //           item.Taxable_amt,
    //           item.grpss_amt_fce,
    //           item.Sgst_per,
    //           item.Sgst_amt,
    //           item.Cgst_per,
    //           item.Cgst_amt,
    //           item.Igst_per,
    //           item.Igst_amt,
    //           item.Net_amt,
    //         ]
    //       : [
    //           index + 1,
    //           item.itemCd,
    //           item.itemDesc,
    //           item.UOM,
    //           item.Hsn_code,
    //           item.PO_qty,
    //           item.Item_rate,
    //           item.Disc_per,
    //           item.Disc_amt,
    //           item.Taxable_amt,
    //           item.grpss_amt_fce,
    //         ];
    //   }),
    //   styles: {
    //     cellWidth: "25px",
    //     fontSize: 8,
    //     lineWidth: 0.5,
    //     lineColor: [0, 0, 0],
    //   },
    //   theme: "grid",
    // });

    ///

    let start1Y = doc.lastAutoTable.finalY + 10;
    const headerss = [
      "",
      "Total Disc Amt",
      "Total Taxable amt",
      "Total SGST AMT",
      "Total CGST Amt",
      "Total IGST Amt",
    ];

    doc.setFontSize(8);

    // Initialize totals
    let totalDiscAmt = 0;
    let totalTaxableAmt = 0;
    let totalSGSTAmt = 0;
    let totalCGSTAmt = 0;
    let totalIGSTAmt = 0;

    // Check the number of rows in PO_DTL
    const rowCount = poData.PO_DTL.length;

    // If there is only one row, display it without calculating totals
    if (rowCount === 1) {
      const item = poData.PO_DTL[0]; // Get the single row data

      doc.autoTable({
        startY: start1Y,
        head: [headerss],
        body: [
          [
            "Totals =",
            parseFloat(item.Disc_amt).toFixed(2),
            parseFloat(item.Taxable_amt).toFixed(2),
            parseFloat(item.Sgst_amt).toFixed(2),
            parseFloat(item.Cgst_amt).toFixed(2),
            parseFloat(item.Igst_amt).toFixed(2),
          ],
        ],
        styles: {
          cellWidth: "25px",
          fontSize: 8,
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
        },
        theme: "grid",
      });
    } else {
      // If there are multiple rows, sum the totals
      poData.PO_DTL.forEach((item) => {
        totalDiscAmt += parseFloat(item.Disc_amt) || 0;
        totalTaxableAmt += parseFloat(item.Taxable_amt) || 0;
        totalSGSTAmt += parseFloat(item.Sgst_amt) || 0;
        totalCGSTAmt += parseFloat(item.Cgst_amt) || 0;
        totalIGSTAmt += parseFloat(item.Igst_amt) || 0;
      });

      // Add the final row with totals
      const totalRow = [
        "Totals =",
        totalDiscAmt.toFixed(2),
        totalTaxableAmt.toFixed(2),
        totalSGSTAmt.toFixed(2),
        totalCGSTAmt.toFixed(2),
        totalIGSTAmt.toFixed(2),
      ];

      // Add only the totals row to the table
      doc.autoTable({
        startY: start1Y,
        head: [headerss],
        body: [totalRow], // Only the totals row
        styles: {
          cellWidth: "25px",
          fontSize: 8,
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
        },
        theme: "grid",
      });
    }
    const xPositionFooterLeft = 10;
    const xPositionFooterRight = 196;
    const xPositionRight = 150;
    const spacingIncrement = 8;
    const xPositionLeft = 10;
    
    let yPositionqw = doc.lastAutoTable.finalY + 10; // Start from the last position
    doc.setFontSize(8);
    
    // Helper function to safely format values
    const safeToFixed = (value) => {
      return value !== undefined && value !== null ? value.toFixed(2) : '0.00';
    };
    
    // Text and amounts to be displayed
    doc.text("Total Net Amt:", xPositionRight, yPositionqw);
    doc.text(
      safeToFixed(
        poData.PO_HDR.Total_amt -
        poData.PO_HDR.Freight_amt -
        poData.PO_HDR.Insurance_amt -
        poData.PO_HDR.Oth_amt
      ),
      xPositionFooterRight,
      yPositionqw,
      { align: "right" }
    );

const iteme = poData.PO_DTL[0];
console.log('this is item of podtl',iteme)

    yPositionqw += spacingIncrement;
    
    doc.text("Freight amt:", xPositionRight, yPositionqw);
    doc.text(safeToFixed(poData.PO_HDR.Freight_amt), xPositionFooterRight, yPositionqw, { align: "right" });
    yPositionqw += spacingIncrement;
    
    doc.text("Insurance amt:", xPositionRight, yPositionqw);
    doc.text(safeToFixed(poData.PO_HDR.Insurance_amt), xPositionFooterRight, yPositionqw, { align: "right" });
    yPositionqw += spacingIncrement;
    
    doc.text("Other amt:", xPositionRight, yPositionqw);
    doc.text(safeToFixed(poData.PO_HDR.Oth_amt), xPositionFooterRight, yPositionqw, { align: "right" });
    yPositionqw += spacingIncrement;
    
    doc.text("Grand Total:", xPositionRight, yPositionqw);
    doc.text(safeToFixed(poData.PO_HDR.Total_amt), xPositionFooterRight, yPositionqw, { align: "right" });
    yPositionqw += spacingIncrement;
    
    doc.text("CGST:", xPositionRight, yPositionqw);
    doc.text(parseFloat(iteme.Cgst_amt).toFixed(2), xPositionFooterRight, yPositionqw, { align: "right" });
    yPositionqw += spacingIncrement;
    
    doc.text("SGST:", xPositionRight, yPositionqw);
    doc.text(parseFloat(iteme.Sgst_amt).toFixed(2), xPositionFooterRight, yPositionqw, { align: "right" });
    yPositionqw += spacingIncrement;
    
    doc.text("IGST:", xPositionRight, yPositionqw);
    doc.text(parseFloat(iteme.Igst_amt).toFixed(2), xPositionFooterRight, yPositionqw, { align: "right" });
    yPositionqw += spacingIncrement;
    


    // Next, displaying "Grand Total in Words" on the next line in the middle or left aligned.
    doc.setFontSize(10); // Make the Grand Total in Words larger

    const totalAmount = poData.PO_HDR.Total_amt; // Assuming poData.PO_HDR.Total_amt contains the total amount
    const integerPart = Math.floor(totalAmount); // Get the integer part (before the decimal)
    const fractionalPart = Math.round((totalAmount - integerPart) * 100); // Get the fractional part (after the decimal)

    // Convert the integer part to words
    const integerInWords = toWords(integerPart).toUpperCase(); // Convert integer part to words

    // Construct the "In Words" text for the integer part only
    let amountInWords = ` ${integerInWords}`;

    // Only add the fractional part if it is not zero
    if (fractionalPart > 0) {
      const fractionalInWords = toWords(fractionalPart).toUpperCase(); // Convert fractional part to words
      amountInWords += ` . ${fractionalInWords} PISA`;
    }

    // Display the "In Words INR" with the conditional "PISA"
    doc.text(
      "In Words INR: " + amountInWords,
      xPositionFooterLeft,
      doc.lastAutoTable.finalY + 60
    );

    // Draw a line after the grand total in words
    const lineStartX = 10;
    const lineEndX = pageWidth - 10; // Full width of the page
    doc.setDrawColor(0, 0, 0); // Set the color for the line (black)
    doc.line(
      lineStartX,
      doc.lastAutoTable.finalY + 70,
      lineEndX,
      doc.lastAutoTable.finalY + 70
    ); // Draw a horizontal line

    // Now displaying the company name and authorized signatory
    doc.setFontSize(10); // Slightly larger font size for this text

    // Display "Company Name"
    doc.text(
      "For:" + filteredCompanyData.name,
      xPositionFooterLeft,
      doc.lastAutoTable.finalY + 80
    );

    const spaceBetween = 10; // This will add extra space between the two lines
    const signatoryPosition = doc.lastAutoTable.finalY + 90 + spaceBetween; // Increased the position by adding space

    // Display "Authorised Signatory"
    doc.text("Authorised Signatory", xPositionFooterLeft, signatoryPosition);

    // another page of pdf start

    doc.addPage(); // Create a new page

    const pageWidthh = doc.internal.pageSize.width;
    const pageHeightt = doc.internal.pageSize.height;
    doc.setLineWidth(1);
    doc.rect(0, 0, pageWidthh, pageHeightt); // Drawing the border

    doc.setFontSize(16); // Larger font size for the heading
    const headingg = "Purchase Order Terms and Conditions";
    const headingWidthh = doc.getTextWidth(headingg); // Calculate the width of the heading
    // const pageWidth = doc.internal.pageSize.width;  // Get the page width
    const xPositionn = (pageWidthh - headingWidthh) / 2; // Calculate X position to center the text
    doc.text(headingg, xPositionn, 30); // Adjust Y position to place it near the top

    const logoUrll = companyDataGST; // Path relative to the public folder
    const logoWidthh = 60; // Width of the logo
    const logoHeightt = 15; // Height of the logo

    // Add the image to the PDF in the top-left corner
    doc.addImage(logoUrll, "PNG", 10, 5, logoWidthh, logoHeightt);

    doc.setFontSize(15);

    let contentStartY = 45; // Adjust the Y position to start below the heading

    // Add footer details again in the new page

    filteredPoData.forEach((item, index) => {
      const line = `${index + 1}:  ${item.remarks}`;
      doc.text(line, 10, contentStartY);
      contentStartY += 10; // Increase the Y position for each item
    });

    doc.addPage(); // Create a new page

    const pageWidthh1 = doc.internal.pageSize.width;
    const pageHeightt1 = doc.internal.pageSize.height;
    doc.setLineWidth(1);
    doc.rect(0, 0, pageWidthh1, pageHeightt1); // Drawing the border

    doc.setFontSize(16); // Larger font size for the heading
    const headingg1 = "Purchase Order Terms and Conditions  - Attachments";
    const headingWidthh1 = doc.getTextWidth(headingg1); // Calculate the width of the heading
    // const pageWidth = doc.internal.pageSize.width;  // Get the page width
    const xPositionn1 = (pageWidthh1 - headingWidthh1) / 2; // Calculate X position to center the text
    doc.text(headingg1, xPositionn1, 30); // Adjust Y position to place it near the top

    const logoUrlll = companyDataGST; // Path relative to the public folder
    const logoWidthhh = 60; // Width of the logo
    const logoHeighttt = 15; // Height of the logo

    // Add the image to the PDF in the top-left corner
    doc.addImage(logoUrlll, "PNG", 10, 5, logoWidthhh, logoHeighttt);

    doc.setFontSize(15);

    let contentStartY1 = 45; // Adjust the Y position to start below the heading

    const maxHeightPerPage = doc.internal.pageSize.height - 50; // Set max height per page (leave some space for margins)

    const imageSpacing = 100; // Space between each image (adjust as necessary)

    filteredPoData
      .filter((item) => item.image1) // Filter out entries where `image1` is empty or null
      .forEach((item) => {
        const imageUrl = item.image1; // Assuming `image1` contains the image URL

        // Check if the current Y position exceeds the max height of the page
        if (contentStartY1 + imageSpacing > maxHeightPerPage) {
          doc.addPage(); // Create a new page if we exceed the max height
          contentStartY1 = 45; // Reset Y position for the new page
        }

        // Draw the page border (always at the beginning of each page)
        const pageWidth = doc.internal.pageSize.width;
        const pageHeight = doc.internal.pageSize.height;
        doc.setLineWidth(1);
        doc.rect(0, 0, pageWidth, pageHeight); // Drawing the border

        // Add the image to the PDF
        doc.addImage(imageUrl, "JPEG", 10, contentStartY1, 100, 100); // Adjust size as needed

        // Move the Y position down for the next image
        contentStartY1 += imageSpacing; // Increase Y position by the height of the image (plus some spacing)
      });

    doc.save("purchase_order.pdf");

    setPoData("");
    setPO_no("");
  };

  const emailPDF = () => {
    if (!PO_no) {
      // Show popup if PO No is not selected
      Swal.fire({
        title: "Please select a PO No",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    const doc = new jsPDF(); // Create a new PDF document

    // Set font for header info
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);

    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    doc.setLineWidth(1);
    doc.rect(0, 0, pageWidth, pageHeight); // Drawing the border

    doc.setFontSize(16); // Larger font size for the heading
    const heading = "Purchase Order";
    const headingWidth = doc.getTextWidth(heading); // Calculate the width of the heading
    // const pageWidth = doc.internal.pageSize.width;  // Get the page width
    const xPosition = (pageWidth - headingWidth) / 2; // Calculate X position to center the text
    doc.text(heading, xPosition, 20); // Adjust Y position to place it near the top

    // Set the font back to normal size after the heading
    doc.setFontSize(8);

    // PO Header Info with better layout
    let yPosition = 30; // Starting Y position for the header info

    // Adjust X positions for each field to get them in a row-like structure
    const col1X = 10; // PO Type, Delivery Terms, Delivery Date, etc.
    const col2X = 80; // PO Date, Item Type, Payment Terms, etc.
    const col3X = 150; // Supplier, Credit Days, Supplier GST, etc.

    const logoUrl = companyDataGST; // Path relative to the public folder
    const logoWidth = 60; // Width of the logo
    const logoHeight = 15; // Height of the logo

    // Add the image to the PDF in the top-left corner
    doc.addImage(logoUrl, "PNG", 10, 5, logoWidth, logoHeight);

    doc.text("TO", col1X, yPosition);

    yPosition += 5; // Move to next line

    doc.text("Supplier            : " + supplierName, col1X, yPosition);
    doc.text("PO NO               : " + PO_no, col2X, yPosition);

    yPosition += 5; // Move to the next line
    doc.text("Address            : " + supplierAdd, col1X, yPosition, {
      maxWidth: 65,
    });
    doc.text(
      "PO Date             : " + formatDateToDDMMYYYY(poData.PO_HDR.PO_Dt),
      col2X,
      yPosition
    );

    yPosition += 15; // Move to the next line
    doc.text(
      " GST                 : " + poData.PO_HDR.Supp_gst,
      col1X,
      yPosition
    );
    doc.text(
      "Delivery Terms   : " + poData.PO_HDR.Deli_terms,
      col2X,
      yPosition
    );

    yPosition += 5; // Move to the next line
    doc.text(" State                : " + stateName, col1X, yPosition);
    doc.text(
      "Delivery Date       : " + formatDateToDDMMYYYY(poData.PO_HDR.Deli_dt),
      col2X,
      yPosition
    );

    yPosition += 5; // Move to the next line
    doc.text("Payment Terms   : " + poData.PO_HDR.Pay_terms, col2X, yPosition);

    yPosition += 5; // Move to the next line
    doc.text("Invoice To", col1X, yPosition);

    yPosition += 5; // Move to the next line
    doc.text(
      "                      " + filteredCompanyData.name,
      col1X,
      yPosition
    );
    yPosition += 5;
    doc.text(
      "                      " + filteredCompanyData.address,
      col1X,
      yPosition
    );
    yPosition += 5;
    doc.text(
      "                      " + filteredCompanyData.GST_NO,
      col1X,
      yPosition
    );

    let startY = yPosition + 10; // Starting Y position for the table
    const headers = [
      "Sl",
      "Item Code",
      "Item Desc",
      "UOM",
      "HSN CODE",
      "PO Qty",
      "Item Rate",
      "Disc %",
      "Disc Amt",
      "Taxable amt",
      "SGST %",
      "SGST AMT",
      "CGST %",
      "CGST Amt",
      "IGST %",
      "IGST Amt",
      "Net Amt",
    ];

    doc.setFontSize(8);

    doc.autoTable({
      startY: startY,
      head: [headers],

      body: poData.PO_DTL.map((item, index) => {
        return [
          index + 1,
          item.itemCd,
          item.itemDesc,
          item.UOM,
          item.Hsn_code,
          item.PO_qty,
          item.Item_rate,
          item.Disc_per,
          item.Disc_amt,
          item.Taxable_amt,
          item.Sgst_per,
          item.Sgst_amt,
          item.Cgst_per,
          item.Cgst_amt,
          item.Igst_per,
          item.Igst_amt,
          item.Net_amt,
        ];
      }),

      styles: {
        cellWidth: "25px", // Adjust the cell width
        fontSize: 8, // Set font size for the table content
        lineWidth: 0.5, // Set line width for borders
        lineColor: [0, 0, 0], // Set line color to black for borders
      },
      theme: "grid",
    });

    let start1Y = doc.lastAutoTable.finalY + 10;
    const headerss = [
      "",
      "Total Disc Amt",
      "Total Taxable amt",
      "Total SGST AMT",
      "Total CGST Amt",
      "Total IGST Amt",
    ];

    doc.setFontSize(8);

    // Initialize totals
    let totalDiscAmt = 0;
    let totalTaxableAmt = 0;
    let totalSGSTAmt = 0;
    let totalCGSTAmt = 0;
    let totalIGSTAmt = 0;

    // Check the number of rows in PO_DTL
    const rowCount = poData.PO_DTL.length;

    // If there is only one row, display it without calculating totals
    if (rowCount === 1) {
      const item = poData.PO_DTL[0]; // Get the single row data

      doc.autoTable({
        startY: start1Y,
        head: [headerss],
        body: [
          [
            "Totals =",
            parseFloat(item.Disc_amt).toFixed(2),
            parseFloat(item.Taxable_amt).toFixed(2),
            parseFloat(item.Sgst_amt).toFixed(2),
            parseFloat(item.Cgst_amt).toFixed(2),
            parseFloat(item.Igst_amt).toFixed(2),
          ],
        ],
        styles: {
          cellWidth: "25px",
          fontSize: 8,
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
        },
        theme: "grid",
      });
    } else {
      // If there are multiple rows, sum the totals
      poData.PO_DTL.forEach((item) => {
        totalDiscAmt += parseFloat(item.Disc_amt) || 0;
        totalTaxableAmt += parseFloat(item.Taxable_amt) || 0;
        totalSGSTAmt += parseFloat(item.Sgst_amt) || 0;
        totalCGSTAmt += parseFloat(item.Cgst_amt) || 0;
        totalIGSTAmt += parseFloat(item.Igst_amt) || 0;
      });

      // Add the final row with totals
      const totalRow = [
        "Totals =",
        totalDiscAmt.toFixed(2),
        totalTaxableAmt.toFixed(2),
        totalSGSTAmt.toFixed(2),
        totalCGSTAmt.toFixed(2),
        totalIGSTAmt.toFixed(2),
      ];

      // Add only the totals row to the table
      doc.autoTable({
        startY: start1Y,
        head: [headerss],
        body: [totalRow], // Only the totals row
        styles: {
          cellWidth: "25px",
          fontSize: 8,
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
        },
        theme: "grid",
      });
    }

    const xPositionFooterLeft = 10;

    const xPositionFooterRight = 186;
    const xPositionRight = 150;
    const spacingIncrement = 8;
    const xPositionLeft = 10;
    doc.setFontSize(8);

    doc.text("Total Net Amt:", xPositionRight, doc.lastAutoTable.finalY + 10);
    doc.text(
      (
        poData.PO_HDR.Total_amt -
        poData.PO_HDR.Freight_amt -
        poData.PO_HDR.Insurance_amt -
        poData.PO_HDR.Oth_amt
      ).toFixed(2),
      xPositionFooterRight,
      doc.lastAutoTable.finalY + 10
    );

    doc.text("Freight amt:", xPositionRight, doc.lastAutoTable.finalY + 20);
    doc.text(
      poData.PO_HDR.Freight_amt.toFixed(2),
      xPositionFooterRight,
      doc.lastAutoTable.finalY + 20
    );

    doc.text("Insurance amt:", xPositionRight, doc.lastAutoTable.finalY + 30);
    doc.text(
      poData.PO_HDR.Insurance_amt.toFixed(2),
      xPositionFooterRight,
      doc.lastAutoTable.finalY + 30
    );

    doc.text("Other amt:", xPositionRight, doc.lastAutoTable.finalY + 40);
    doc.text(
      poData.PO_HDR.Oth_amt.toFixed(2),
      xPositionFooterRight,
      doc.lastAutoTable.finalY + 40
    );

    doc.text("Grand Total:", xPositionRight, doc.lastAutoTable.finalY + 50);
    doc.text(
      poData.PO_HDR.Total_amt.toFixed(2),
      xPositionFooterRight,
      doc.lastAutoTable.finalY + 50
    );

    // Next, displaying "Grand Total in Words" on the next line in the middle or left aligned.
    doc.setFontSize(10); // Make the Grand Total in Words larger

    const totalAmount = poData.PO_HDR.Total_amt; // Assuming poData.PO_HDR.Total_amt contains the total amount
    const integerPart = Math.floor(totalAmount); // Get the integer part (before the decimal)
    const fractionalPart = Math.round((totalAmount - integerPart) * 100); // Get the fractional part (after the decimal)

    // Convert the integer part to words
    const integerInWords = toWords(integerPart).toUpperCase(); // Convert integer part to words

    // Construct the "In Words" text for the integer part only
    let amountInWords = ` ${integerInWords}`;

    // Only add the fractional part if it is not zero
    if (fractionalPart > 0) {
      const fractionalInWords = toWords(fractionalPart).toUpperCase(); // Convert fractional part to words
      amountInWords += ` . ${fractionalInWords} PISA`;
    }

    // Display the "In Words INR" with the conditional "PISA"
    doc.text(
      "In Words INR: " + amountInWords,
      xPositionFooterLeft,
      doc.lastAutoTable.finalY + 60
    );

    // Draw a line after the grand total in words
    const lineStartX = 10;
    const lineEndX = pageWidth - 10; // Full width of the page
    doc.setDrawColor(0, 0, 0); // Set the color for the line (black)
    doc.line(
      lineStartX,
      doc.lastAutoTable.finalY + 70,
      lineEndX,
      doc.lastAutoTable.finalY + 70
    ); // Draw a horizontal line

    // Now displaying the company name and authorized signatory
    doc.setFontSize(10); // Slightly larger font size for this text

    // Display "Company Name"
    doc.text(
      "For:" + filteredCompanyData.name,
      xPositionFooterLeft,
      doc.lastAutoTable.finalY + 80
    );

    const spaceBetween = 10; // This will add extra space between the two lines
    const signatoryPosition = doc.lastAutoTable.finalY + 90 + spaceBetween; // Increased the position by adding space

    // Display "Authorised Signatory"
    doc.text("Authorised Signatory", xPositionFooterLeft, signatoryPosition);

    // another page of pdf start

    doc.addPage(); // Create a new page

    const pageWidthh = doc.internal.pageSize.width;
    const pageHeightt = doc.internal.pageSize.height;
    doc.setLineWidth(1);
    doc.rect(0, 0, pageWidthh, pageHeightt); // Drawing the border

    doc.setFontSize(16); // Larger font size for the heading
    const headingg = "Purchase Order Terms and Conditions";
    const headingWidthh = doc.getTextWidth(headingg); // Calculate the width of the heading
    // const pageWidth = doc.internal.pageSize.width;  // Get the page width
    const xPositionn = (pageWidthh - headingWidthh) / 2; // Calculate X position to center the text
    doc.text(headingg, xPositionn, 30); // Adjust Y position to place it near the top

    const logoUrll = companyDataGST; // Path relative to the public folder
    const logoWidthh = 60; // Width of the logo
    const logoHeightt = 15; // Height of the logo

    // Add the image to the PDF in the top-left corner
    doc.addImage(logoUrll, "PNG", 10, 5, logoWidthh, logoHeightt);

    doc.setFontSize(15);

    let contentStartY = 45; // Adjust the Y position to start below the heading

    // Add footer details again in the new page

    filteredPoData.forEach((item, index) => {
      const line = `${index + 1}:  ${item.remarks}`;
      doc.text(line, 10, contentStartY);
      contentStartY += 10; // Increase the Y position for each item
    });

    doc.addPage(); // Create a new page

    const pageWidthh1 = doc.internal.pageSize.width;
    const pageHeightt1 = doc.internal.pageSize.height;
    doc.setLineWidth(1);
    doc.rect(0, 0, pageWidthh1, pageHeightt1); // Drawing the border

    doc.setFontSize(16); // Larger font size for the heading
    const headingg1 = "Purchase Order Terms and Conditions  - Attachments";
    const headingWidthh1 = doc.getTextWidth(headingg1); // Calculate the width of the heading
    // const pageWidth = doc.internal.pageSize.width;  // Get the page width
    const xPositionn1 = (pageWidthh1 - headingWidthh1) / 2; // Calculate X position to center the text
    doc.text(headingg1, xPositionn1, 30); // Adjust Y position to place it near the top

    const logoUrlll = companyDataGST; // Path relative to the public folder
    const logoWidthhh = 60; // Width of the logo
    const logoHeighttt = 15; // Height of the logo

    // Add the image to the PDF in the top-left corner
    doc.addImage(logoUrlll, "PNG", 10, 5, logoWidthhh, logoHeighttt);
    doc.setFontSize(15);

    let contentStartY1 = 45; // Adjust the Y position to start below the heading

    const maxHeightPerPage = doc.internal.pageSize.height - 50; // Set max height per page (leave some space for margins)

    const imageSpacing = 100; // Space between each image (adjust as necessary)

    filteredPoData
      .filter((item) => item.image1) // Filter out entries where `image1` is empty or null
      .forEach((item) => {
        const imageUrl = item.image1; // Assuming `image1` contains the image URL

        // Check if the current Y position exceeds the max height of the page
        if (contentStartY1 + imageSpacing > maxHeightPerPage) {
          doc.addPage(); // Create a new page if we exceed the max height
          contentStartY1 = 45; // Reset Y position for the new page
        }

        // Draw the page border (always at the beginning of each page)
        const pageWidth = doc.internal.pageSize.width;
        const pageHeight = doc.internal.pageSize.height;
        doc.setLineWidth(1);
        doc.rect(0, 0, pageWidth, pageHeight); // Drawing the border

        // Add the image to the PDF
        doc.addImage(imageUrl, "JPEG", 10, contentStartY1, 100, 100); // Adjust size as needed

        // Move the Y position down for the next image
        contentStartY1 += imageSpacing; // Increase Y position by the height of the image (plus some spacing)
      });

    // doc.save("purchase_order.pdf");

    const pdfBlob = doc.output("blob");
    console.log(pdfBlob, pdfBlob instanceof Blob); // Should output true if it's a Blob
    // Send the PDF blob to the backend
    sendPDFToBackend(pdfBlob);
    SavePDF(pdfBlob);
    setPoData("");
    setPO_no("");
  };

  const pdfsave = () => {
    const doc = new jsPDF(); // Create a new PDF document

    // Set font for header info
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);

    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    doc.setLineWidth(1);
    doc.rect(0, 0, pageWidth, pageHeight); // Drawing the border

    doc.setFontSize(16); // Larger font size for the heading
    const heading = "Purchase Order";
    const headingWidth = doc.getTextWidth(heading); // Calculate the width of the heading
    // const pageWidth = doc.internal.pageSize.width;  // Get the page width
    const xPosition = (pageWidth - headingWidth) / 2; // Calculate X position to center the text
    doc.text(heading, xPosition, 20); // Adjust Y position to place it near the top

    // Set the font back to normal size after the heading
    doc.setFontSize(8);

    // PO Header Info with better layout
    let yPosition = 30; // Starting Y position for the header info

    // Adjust X positions for each field to get them in a row-like structure
    const col1X = 10; // PO Type, Delivery Terms, Delivery Date, etc.
    const col2X = 80; // PO Date, Item Type, Payment Terms, etc.
    const col3X = 150; // Supplier, Credit Days, Supplier GST, etc.

    const logoUrl = companyDataGST; // Path relative to the public folder
    const logoWidth = 60; // Width of the logo
    const logoHeight = 15; // Height of the logo

    // Add the image to the PDF in the top-left corner
    doc.addImage(logoUrl, "PNG", 10, 5, logoWidth, logoHeight);

    doc.text("TO", col1X, yPosition);

    yPosition += 5; // Move to next line

    doc.text("Supplier            : " + supplierName, col1X, yPosition);
    doc.text("PO NO               : " + PO_no, col2X, yPosition);

    yPosition += 5; // Move to the next line
    doc.text("Address            : " + supplierAdd, col1X, yPosition, {
      maxWidth: 65,
    });
    doc.text(
      "PO Date             : " + formatDateToDDMMYYYY(poData.PO_HDR.PO_Dt),
      col2X,
      yPosition
    );

    yPosition += 15; // Move to the next line
    doc.text(
      " GST                 : " + poData.PO_HDR.Supp_gst,
      col1X,
      yPosition
    );
    doc.text(
      "Delivery Terms   : " + poData.PO_HDR.Deli_terms,
      col2X,
      yPosition
    );

    yPosition += 5; // Move to the next line
    doc.text(" State                : " + stateName, col1X, yPosition);
    doc.text(
      "Delivery Date       : " + formatDateToDDMMYYYY(poData.PO_HDR.Deli_dt),
      col2X,
      yPosition
    );

    yPosition += 5; // Move to the next line
    doc.text("Payment Terms   : " + poData.PO_HDR.Pay_terms, col2X, yPosition);

    yPosition += 5; // Move to the next line
    doc.text("Invoice To", col1X, yPosition);

    yPosition += 5; // Move to the next line
    doc.text(
      "                      " + filteredCompanyData.name,
      col1X,
      yPosition
    );
    yPosition += 5;
    doc.text(
      "                      " + filteredCompanyData.address,
      col1X,
      yPosition
    );
    yPosition += 5;
    doc.text(
      "                      " + filteredCompanyData.GST_NO,
      col1X,
      yPosition
    );

    let startY = yPosition + 10; // Starting Y position for the table
    const headers = [
      "Sl",
      "Item Code",
      "Item Desc",
      "UOM",
      "HSN CODE",
      "PO Qty",
      "Item Rate",
      "Disc %",
      "Disc Amt",
      "Taxable amt",
      "SGST %",
      "SGST AMT",
      "CGST %",
      "CGST Amt",
      "IGST %",
      "IGST Amt",
      "Net Amt",
    ];

    doc.setFontSize(8);

    doc.autoTable({
      startY: startY,
      head: [headers],

      body: poData.PO_DTL.map((item, index) => {
        return [
          index + 1,
          item.itemCd,
          item.itemDesc,
          item.UOM,
          item.Hsn_code,
          item.PO_qty,
          item.Item_rate,
          item.Disc_per,
          item.Disc_amt,
          item.Taxable_amt,
          item.Sgst_per,
          item.Sgst_amt,
          item.Cgst_per,
          item.Cgst_amt,
          item.Igst_per,
          item.Igst_amt,
          item.Net_amt,
        ];
      }),

      styles: {
        cellWidth: "25px", // Adjust the cell width
        fontSize: 8, // Set font size for the table content
        lineWidth: 0.5, // Set line width for borders
        lineColor: [0, 0, 0], // Set line color to black for borders
      },
      theme: "grid",
    });

    let start1Y = doc.lastAutoTable.finalY + 10;
    const headerss = [
      "",
      "Total Disc Amt",
      "Total Taxable amt",
      "Total SGST AMT",
      "Total CGST Amt",
      "Total IGST Amt",
    ];

    doc.setFontSize(8);

    // Initialize totals
    let totalDiscAmt = 0;
    let totalTaxableAmt = 0;
    let totalSGSTAmt = 0;
    let totalCGSTAmt = 0;
    let totalIGSTAmt = 0;

    // Check the number of rows in PO_DTL
    const rowCount = poData.PO_DTL.length;

    // If there is only one row, display it without calculating totals
    if (rowCount === 1) {
      const item = poData.PO_DTL[0]; // Get the single row data

      doc.autoTable({
        startY: start1Y,
        head: [headerss],
        body: [
          [
            "Totals =",
            parseFloat(item.Disc_amt).toFixed(2),
            parseFloat(item.Taxable_amt).toFixed(2),
            parseFloat(item.Sgst_amt).toFixed(2),
            parseFloat(item.Cgst_amt).toFixed(2),
            parseFloat(item.Igst_amt).toFixed(2),
          ],
        ],
        styles: {
          cellWidth: "25px",
          fontSize: 8,
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
        },
        theme: "grid",
      });
    } else {
      // If there are multiple rows, sum the totals
      poData.PO_DTL.forEach((item) => {
        totalDiscAmt += parseFloat(item.Disc_amt) || 0;
        totalTaxableAmt += parseFloat(item.Taxable_amt) || 0;
        totalSGSTAmt += parseFloat(item.Sgst_amt) || 0;
        totalCGSTAmt += parseFloat(item.Cgst_amt) || 0;
        totalIGSTAmt += parseFloat(item.Igst_amt) || 0;
      });

      // Add the final row with totals
      const totalRow = [
        "Totals =",
        totalDiscAmt.toFixed(2),
        totalTaxableAmt.toFixed(2),
        totalSGSTAmt.toFixed(2),
        totalCGSTAmt.toFixed(2),
        totalIGSTAmt.toFixed(2),
      ];

      // Add only the totals row to the table
      doc.autoTable({
        startY: start1Y,
        head: [headerss],
        body: [totalRow], // Only the totals row
        styles: {
          cellWidth: "25px",
          fontSize: 8,
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
        },
        theme: "grid",
      });
    }

    const xPositionFooterLeft = 10;

    const xPositionFooterRight = 186;
    const xPositionRight = 150;
    const spacingIncrement = 8;
    const xPositionLeft = 10;
    doc.setFontSize(8);

    doc.text("Total Net Amt:", xPositionRight, doc.lastAutoTable.finalY + 10);
    doc.text(
      (
        poData.PO_HDR.Total_amt -
        poData.PO_HDR.Freight_amt -
        poData.PO_HDR.Insurance_amt -
        poData.PO_HDR.Oth_amt
      ).toFixed(2),
      xPositionFooterRight,
      doc.lastAutoTable.finalY + 10
    );

    doc.text("Freight amt:", xPositionRight, doc.lastAutoTable.finalY + 20);
    doc.text(
      poData.PO_HDR.Freight_amt.toFixed(2),
      xPositionFooterRight,
      doc.lastAutoTable.finalY + 20
    );

    doc.text("Insurance amt:", xPositionRight, doc.lastAutoTable.finalY + 30);
    doc.text(
      poData.PO_HDR.Insurance_amt.toFixed(2),
      xPositionFooterRight,
      doc.lastAutoTable.finalY + 30
    );

    doc.text("Other amt:", xPositionRight, doc.lastAutoTable.finalY + 40);
    doc.text(
      poData.PO_HDR.Oth_amt.toFixed(2),
      xPositionFooterRight,
      doc.lastAutoTable.finalY + 40
    );

    doc.text("Grand Total:", xPositionRight, doc.lastAutoTable.finalY + 50);
    doc.text(
      poData.PO_HDR.Total_amt.toFixed(2),
      xPositionFooterRight,
      doc.lastAutoTable.finalY + 50
    );

    // Next, displaying "Grand Total in Words" on the next line in the middle or left aligned.
    doc.setFontSize(10); // Make the Grand Total in Words larger

    const totalAmount = poData.PO_HDR.Total_amt; // Assuming poData.PO_HDR.Total_amt contains the total amount
    const integerPart = Math.floor(totalAmount); // Get the integer part (before the decimal)
    const fractionalPart = Math.round((totalAmount - integerPart) * 100); // Get the fractional part (after the decimal)

    // Convert the integer part to words
    const integerInWords = toWords(integerPart).toUpperCase(); // Convert integer part to words

    // Construct the "In Words" text for the integer part only
    let amountInWords = ` ${integerInWords}`;

    // Only add the fractional part if it is not zero
    if (fractionalPart > 0) {
      const fractionalInWords = toWords(fractionalPart).toUpperCase(); // Convert fractional part to words
      amountInWords += ` . ${fractionalInWords} PISA`;
    }

    // Display the "In Words INR" with the conditional "PISA"
    doc.text(
      "In Words INR: " + amountInWords,
      xPositionFooterLeft,
      doc.lastAutoTable.finalY + 60
    );

    // Draw a line after the grand total in words
    const lineStartX = 10;
    const lineEndX = pageWidth - 10; // Full width of the page
    doc.setDrawColor(0, 0, 0); // Set the color for the line (black)
    doc.line(
      lineStartX,
      doc.lastAutoTable.finalY + 70,
      lineEndX,
      doc.lastAutoTable.finalY + 70
    ); // Draw a horizontal line

    // Now displaying the company name and authorized signatory
    doc.setFontSize(10); // Slightly larger font size for this text

    // Display "Company Name"
    doc.text(
      "For:" + filteredCompanyData.name,
      xPositionFooterLeft,
      doc.lastAutoTable.finalY + 80
    );

    const spaceBetween = 10; // This will add extra space between the two lines
    const signatoryPosition = doc.lastAutoTable.finalY + 90 + spaceBetween; // Increased the position by adding space

    // Display "Authorised Signatory"
    doc.text("Authorised Signatory", xPositionFooterLeft, signatoryPosition);

    // another page of pdf start

    doc.addPage(); // Create a new page

    const pageWidthh = doc.internal.pageSize.width;
    const pageHeightt = doc.internal.pageSize.height;
    doc.setLineWidth(1);
    doc.rect(0, 0, pageWidthh, pageHeightt); // Drawing the border

    doc.setFontSize(16); // Larger font size for the heading
    const headingg = "Purchase Order Terms and Conditions";
    const headingWidthh = doc.getTextWidth(headingg); // Calculate the width of the heading
    // const pageWidth = doc.internal.pageSize.width;  // Get the page width
    const xPositionn = (pageWidthh - headingWidthh) / 2; // Calculate X position to center the text
    doc.text(headingg, xPositionn, 30); // Adjust Y position to place it near the top

    const logoUrll = companyDataGST; // Path relative to the public folder
    const logoWidthh = 60; // Width of the logo
    const logoHeightt = 15; // Height of the logo

    // Add the image to the PDF in the top-left corner
    doc.addImage(logoUrll, "PNG", 10, 5, logoWidthh, logoHeightt);

    doc.setFontSize(15);

    let contentStartY = 45; // Adjust the Y position to start below the heading

    // Add footer details again in the new page

    filteredPoData.forEach((item, index) => {
      const line = `${index + 1}:  ${item.remarks}`;
      doc.text(line, 10, contentStartY);
      contentStartY += 10; // Increase the Y position for each item
    });

    doc.addPage(); // Create a new page

    const pageWidthh1 = doc.internal.pageSize.width;
    const pageHeightt1 = doc.internal.pageSize.height;
    doc.setLineWidth(1);
    doc.rect(0, 0, pageWidthh1, pageHeightt1); // Drawing the border

    doc.setFontSize(16); // Larger font size for the heading
    const headingg1 = "Purchase Order Terms and Conditions  - Attachments";
    const headingWidthh1 = doc.getTextWidth(headingg1); // Calculate the width of the heading
    // const pageWidth = doc.internal.pageSize.width;  // Get the page width
    const xPositionn1 = (pageWidthh1 - headingWidthh1) / 2; // Calculate X position to center the text
    doc.text(headingg1, xPositionn1, 30); // Adjust Y position to place it near the top
    const logoUrlll = companyDataGST; // Path relative to the public folder
    const logoWidthhh = 60; // Width of the logo
    const logoHeighttt = 15; // Height of the logo

    // Add the image to the PDF in the top-left corner
    doc.addImage(logoUrlll, "PNG", 10, 5, logoWidthhh, logoHeighttt);

    doc.setFontSize(15);

    let contentStartY1 = 45; // Adjust the Y position to start below the heading

    const maxHeightPerPage = doc.internal.pageSize.height - 50; // Set max height per page (leave some space for margins)

    const imageSpacing = 100; // Space between each image (adjust as necessary)

    filteredPoData
      .filter((item) => item.image1) // Filter out entries where `image1` is empty or null
      .forEach((item) => {
        const imageUrl = item.image1; // Assuming `image1` contains the image URL

        // Check if the current Y position exceeds the max height of the page
        if (contentStartY1 + imageSpacing > maxHeightPerPage) {
          doc.addPage(); // Create a new page if we exceed the max height
          contentStartY1 = 45; // Reset Y position for the new page
        }

        // Draw the page border (always at the beginning of each page)
        const pageWidth = doc.internal.pageSize.width;
        const pageHeight = doc.internal.pageSize.height;
        doc.setLineWidth(1);
        doc.rect(0, 0, pageWidth, pageHeight); // Drawing the border

        // Add the image to the PDF
        doc.addImage(imageUrl, "JPEG", 10, contentStartY1, 100, 100); // Adjust size as needed

        // Move the Y position down for the next image
        contentStartY1 += imageSpacing; // Increase Y position by the height of the image (plus some spacing)
      });

    // doc.save("purchase_order.pdf");

    const pdfBlob = doc.output("blob");
    console.log(pdfBlob, pdfBlob instanceof Blob); // Should output true if it's a Blob
    // Send the PDF blob to the backend

    SavePDF(pdfBlob, PO_no);
    setShowWhatsAppButton(true);
    setPoData("");
    setPO_no("");
  };

  // const SavePDF = (pdfBlob) => {
  //     console.log(pdfBlob);  // Debugging the PDF Blob before sending it

  //     const formData = new FormData();
  //     if (pdfBlob instanceof Blob) {
  //         formData.append('pdf', pdfBlob, 'purchase_order.pdf');
  //         console.log('PDF Blob is valid, sending to backend...');
  //     } else {
  //         console.error('The provided pdfBlob is not a valid Blob:', pdfBlob);
  //         return;
  //     }

  //     fetch('https://erpapi.emedha.in/pages/api/api/save-pdf', {
  //         method: 'POST',
  //         body: formData
  //     })
  //     .then(response => response.json())
  //     .then(data => {
  //         console.log(data);
  //         if (data.success) {
  //             console.log('PDF saved successfully:', data.pdfUrl);
  //         } else {
  //             console.error('Error saving PDF:', data.error);
  //         }
  //     })
  //     .catch(err => {
  //         console.error('Error:', err);
  //     });
  // };

  const SavePDF = (pdfBlob, PO_no) => {
    console.log(pdfBlob); // Debugging the PDF Blob before sending it
    console.log("PO No:", PO_no); // Debugging the PO number before sending it

    const formData = new FormData();

    // Append the PDF Blob to FormData
    if (pdfBlob instanceof Blob) {
      formData.append("pdf", pdfBlob, "purchase_order.pdf");
      console.log("PDF Blob is valid, sending to backend...");
    } else {
      console.error("The provided pdfBlob is not a valid Blob:", pdfBlob);
      return;
    }

    // Append the PO number to FormData
    if (PO_no) {
      formData.append("PO_no", PO_no);
      console.log("PO number added to FormData");
    } else {
      console.error("PO number is missing!");
    }

    // Send the data to the backend
    fetch("https://erpapi.emedha.in/pages/api/api/save-pdf", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.success) {
          console.log("PDF saved successfully:", data.pdfUrl);
          alert("PDF saved successfully:", data.pdfUrl);
          window.location.reload();
          fetchPoData();
        } else {
          console.error("Error saving PDF:", data.error);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const sendPDFToBackend = (pdfBlob) => {
    const formData = new FormData();

    if (pdfBlob instanceof Blob) {
      formData.append("pdf", pdfBlob, "purchase_order.pdf");
      formData.append("supplierEmail", supplierEmail);
      console.log("PDF Blob is valid, sending to backend...");
    } else {
      console.error("The provided pdfBlob is not a valid Blob:", pdfBlob);
      return;
    }

    fetch("https://erpapi.emedha.in/pages/api/send-email", {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        console.log("Response status:", response.status);

        // Check if the response is JSON (based on content type)
        const contentType = response.headers.get("Content-Type");
        if (contentType && contentType.includes("application/json")) {
          return response.json(); // Parse as JSON if content-type is JSON
        } else {
          // If it's not JSON, handle it as text
          return response.text(); // Parse as plain text
        }
      })
      .then((data) => {
        console.log("Response data:", data);

        // Check if response is JSON and has a success flag
        if (typeof data === "string" && data.includes("Email sent")) {
          // Handle plain text response
          alert("Email sent successfully to the Supplier");
        } else if (data.success) {
          alert("Email sent successfully to the Supplier");
        } else {
          console.error(
            "Error in backend response:",
            data.message || "Unknown error"
          );
        }
      })
      .catch((error) => {
        console.error("Error sending email:", error);
      });
  };

  console.log("PO_no type:", typeof PO_no);
  console.log("PO_no value:", PO_no);

  const handleEmailClick = () => {
    const doc = new jsPDF();
    // Generate the PDF content here (same as your original code)

    // Assuming you generate your PDF content here, like adding tables, text, etc.

    // Convert the PDF to Blob
    const pdfBlob = doc.output("blob");
    console.log(pdfBlob, pdfBlob instanceof Blob); // Should output true if it's a Blob

    // Send the PDF to the backend for email
    sendPDFToBackend(pdfBlob);
  };
  const handlePrint = () => {
    const poData = `${poData.HDR} ${poData.DTL}`; // Assuming you have the data to pass into the component

    // Create the React component for the PDF
    const doc = (
      <MyDocument
        poData={poData}
        stateNamee={stateNamee}
        stateName={stateName}
        supplierName={supplierName}
        formatDateToDateInput={formatDateToDateInput}
      />
    );

    // Use the pdf function to generate a PDF from the React component
    pdf(doc)
      .toBlob()
      .then((blob) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob); // Create a URL for the Blob data
        link.download = "purchase-order.pdf"; // Set the filename for the download
        link.click(); // Trigger the download of the PDF
      });
  };

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pdf1, setPdf1] = useState(null);
  const [pdf2, setPdf2] = useState(null);
  const [wordOrPdf, setWordOrPdf] = useState(null);
  const [images, setImages] = useState([]);

  const handleFileChange = (e, setFile) => {
    const file = e.target.files[0];
    if (file) {
      setFile(file);
    }
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setImages(files);
  };

  const combineFiles = () => {
    const doc = new jsPDF();

    // Add PDF 1
    if (pdf1) {
      const reader = new FileReader();
      reader.onload = () => {
        const pdfData = new Uint8Array(reader.result);
        doc.addPage();
        doc.text("PDF 1 content", 10, 10);
        // You can use `pdf-lib` or other libraries to merge actual PDF content here
      };
      reader.readAsArrayBuffer(pdf1);
    }

    // Add PDF 2
    if (pdf2) {
      const reader = new FileReader();
      reader.onload = () => {
        const pdfData = new Uint8Array(reader.result);
        doc.addPage();
        doc.text("PDF 2 content", 10, 10);
        // Similar logic for merging PDF 2
      };
      reader.readAsArrayBuffer(pdf2);
    }

    // Add Word/PDF
    if (wordOrPdf) {
      const reader = new FileReader();
      reader.onload = () => {
        const wordPdfData = new Uint8Array(reader.result);
        doc.addPage();
        doc.text("Word/PDF content", 10, 10);
        // Handle the Word or PDF conversion here if needed
      };
      reader.readAsArrayBuffer(wordOrPdf);
    }

    // Add Images
    if (images.length > 0) {
      images.forEach((image, index) => {
        const reader = new FileReader();
        reader.onload = () => {
          const imgData = reader.result;
          doc.addPage();
          doc.addImage(imgData, "PNG", 10, 10, 180, 180);
        };
        reader.readAsDataURL(image);
      });
    }

    // Save the combined PDF
    doc.save("combined-file.pdf");
    closeModal();
  };

  // const handleWhatsAppClick = () => {

  //     // Log the values for testing
  //     console.log('Supplier Name:', supplierName);
  //     console.log('Supplier Phone Number:', supplierPhoneNumber);

  //     // Trigger API with the selected PO No, Supplier Phone Number, and Supplier Name
  //     fetch('https://emedha.com/echatbot/erppo.php', {
  //         method: 'POST',
  //         headers: {
  //             'Content-Type': 'application/json',
  //         },
  //         body: JSON.stringify({
  //             mobile: supplierPhoneNumber,
  //             name: supplierName,
  //             link: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
  //         }),
  //     })
  //         .then((response) => response.json())
  //         .then((data) => {
  //             console.log('API Response:', data);
  //             // Handle API response
  //         })
  //         .catch((error) => {
  //             console.error('API Error:', error);
  //         });
  // };

  const handleWhatsAppClick = () => {
    // Log the values for testing
    console.log("Supplier Name:", supplierName);
    console.log("Supplier Phone Number:", supplierPhoneNumber);
    console.log("PDF URL:", pdfUrl);
    // Show a confirmation alert using SweetAlert2
    Swal.fire({
      title: "Send PDF",
      text: `Are you sure you want to send the PDF to ${supplierName} (${supplierPhoneNumber})?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, send it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        // Trigger API with the selected PO No, Supplier Phone Number, and Supplier Name
        fetch("https://emedha.com/echatbot/erppo.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            mobile: supplierPhoneNumber,
            name: supplierName,
            link: pdfUrl,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("API Response:", data);

            // Show success message using SweetAlert2
            Swal.fire({
              title: "Success!",
              text: "PDF has been successfully sent to " + supplierPhoneNumber,
              icon: "success",
              confirmButtonText: "Great!",
            });
            closeModalWhatsapp();
            setShowWhatsAppButton(false);
          })
          .catch((error) => {
            console.error("API Error:", error);

            // Show error message if something went wrong
            Swal.fire({
              title: "Error",
              text: "There was an issue sending the PDF. Please try again.",
              icon: "error",
              confirmButtonText: "OK",
            });
          });
      }
    });
  };

  const [isModalOpenWhatsapp, setIsModalOpenWhastapp] = useState(false);
  const [showWhatsAppButton, setShowWhatsAppButton] = useState(false);

  const openModalWhatsapp = () => {
    if (!PO_no) {
      // Show popup if PO No is not selected
      Swal.fire({
        title: "Please select a PO No",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    setIsModalOpenWhastapp(true);
    // Show WhatsApp button when modal opens
  };

  const closeModalWhatsapp = () => {
    setIsModalOpenWhastapp(false);
    setShowWhatsAppButton(false);
  };

  return (
    <div
      style={{
        margin: "0 auto",
        backgroundColor: "#ffffff",
        padding: "1rem",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        border: "1px solid black",
        borderRadius: "10px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <img src={A1} alt="item" style={{ width: "20%" }} />
        <h1
          style={{
            color: "darkblue",
            fontSize: "1.95rem",
            fontWeight: "1000",
            marginBottom: "1rem",
          }}
        >
          PURCHASEORDER VS SUPPLIER
        </h1>
        <div style={{ display: "flex", gap: "1rem", cursor: "pointer" }}>
          <div
            style={{
              width: "40px",
              height: "40px",
              backgroundColor: "white",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "8px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
            title="Email"
          >
            <IoMail onClick={emailPDF} size={30} />
          </div>

          {/* <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    }} title='PDF'>
                        <BsFilePdf onClick={pdfsave} size={30} />
                    </div> */}
          {/* <div
                        onClick={handleWhatsAppClick}
                        style={{  width: "40px", height: "40px",display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", }}
                    >
                        <img
                            src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" // Use your WhatsApp icon here
                            alt="WhatsApp Icon"
                            width="50"
                            height="50"
                        />
                    </div> */}

          <div
            onClick={openModalWhatsapp}
            style={{
              width: "40px",
              height: "40px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "8px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
              alt="WhatsApp Icon"
              width="50"
              height="50"
            />
          </div>

          <div
            style={{
              width: "40px",
              height: "40px",
              backgroundColor: "white",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "8px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
            title="Print"
          >
            <IoPrint onClick={generatePDF} size={30} />
          </div>
          {/* <div style={{  SavePDF
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        cursor: userPermissions.close && userPermissions.close !== 0 && getButtonState('close') ? "pointer" : "not-allowed",
                        opacity: userPermissions.close && userPermissions.close !== 0 && getButtonState('close') ? 1 : 0.5
                    }} title='Exit'>
                        <RiCloseLargeFill size={30} onClick={userPermissions.close && userPermissions.close !== 0 ? handleBack : null} />
                    </div> */}
          <div
            style={{
              width: "40px",
              height: "40px",
              backgroundColor: "white",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "8px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              // cursor: userPermissions.close && userPermissions.close !== 0 && getButtonState('close') ? "pointer" : "not-allowed",
              // opacity: userPermissions.close && userPermissions.close !== 0 && getButtonState('close') ? 1 : 0.5
            }}
            title="Exit"
          >
            <RiCloseLargeFill
              size={30}
              onClick={handleBack}
              //  onClick={userPermissions.close && userPermissions.close !== 0 ? handleBack : null}
            />
          </div>
        </div>
      </div>
      <hr />

      <>
        <Container style={{ height: "400px" }}>
          <Row>
            <Col md={12}>
              <div className="text-center">
                <h2>Print PurchaseOrder</h2>
              </div>
            </Col>
            <br></br>
          </Row>

          <Row className="mt-4">
            <Col>
              <div>
                <Row>
                  <Col md={4} style={{ display: "flex", alignItems: "end" }}>
                    <label style={{ marginRight: "105px", color: "darkblue" }}>
                      Select PO No :
                    </label>

                    <Select
                      key={PO_no}
                      options={poOptions}
                      value={poOptions.find((option) => option.value === PO_no)}
                      onChange={handlePOSelectChange}
                      placeholder="Select PO No"
                      styles={{
                        container: (provided) => ({
                          ...provided,
                          width: "40%",
                        }),
                        menuPortal: (provided) => ({
                          ...provided,
                          zIndex: 9999,
                        }),
                        menu: (provided) => ({
                          ...provided,
                          width: "50%",
                          overflowY: "auto",
                        }),
                        control: (provided) => ({
                          ...provided,
                          backgroundColor: "transparent",
                          height: "25px",
                          padding: "4px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          color: "black",
                        }),
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  {PO_no && (
                    <div style={{ marginTop: "10px", color: "green" }}>
                      Click on the Print to get the PDF
                    </div>
                  )}
                </Row>
              </div>
            </Col>
          </Row>
          <br></br>
        </Container>
      </>

      <Modal
        isOpen={isModalOpenWhatsapp}
        onRequestClose={closeModalWhatsapp}
        contentLabel="Modal"
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Dark background overlay
          },
          content: {
            width: "350px", // Adjust width of the modal
            height: "250px", // Adjust height of the modal
            margin: "auto",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: "30px",
            borderRadius: "10px", // Rounded corners
            position: "relative", // For positioning the close button
            backgroundColor: "#fff", // White background
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)", // Soft shadow effect
          },
        }}
      >
        {/* Close button (X) at the top-right */}
        <button
          onClick={closeModalWhatsapp}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "none",
            border: "none",
            fontSize: "20px",
            cursor: "pointer",
            color: "#000", // Color of the close icon
          }}
        >
          <MdClose />
        </button>

        {/* Initially show only the PDF button */}
        <div>Save PDF to Send WhatsApp</div>
        <div
          style={{
            width: "150px",
            height: "40px",
            backgroundColor: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "8px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            cursor: "pointer", // Change cursor to pointer
          }}
          title="PDF"
          onClick={pdfsave} // When clicked, show the WhatsApp button
        >
          <BsFilePdf size={30} />
        </div>

        {/* Conditionally show the WhatsApp button after PDF button is clicked */}
        {showWhatsAppButton && (
          <>
            <div> Send WhatsApp</div>
            <div
              onClick={handleWhatsAppClick}
              style={{
                width: "40px",
                height: "40px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                marginTop: "20px", // Add some spacing between the buttons
                cursor: "pointer", // Change cursor to pointer
              }}
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                alt="WhatsApp Icon"
                width="50"
                height="50"
              />
            </div>
          </>
        )}

        {/* Close Modal Button */}
        {/* <button onClick={closeModalWhatsapp}>Close Modal</button> */}
      </Modal>
    </div>
  );
};

export default POvsSupplier;

{
  /* {poData && !loading && !error && (
                                    <div>



                                        <div><h5>TO</h5></div>

                                        <div className='p-1' style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px' }}>


                                            <div>



                                                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '64px', color: 'darkblue' }}>Supplier:</label>

                                                    <input value={supplierName} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '2px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} disabled={formMode === 'view'} />
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '32px', color: 'darkblue' }}>Supplier GST:</label>
                                                    <input type="text" name="Supp_gst" value={poData.PO_HDR.Supp_gst} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '2px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} disabled={formMode === 'view'} />
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '25px', color: 'darkblue' }}>Supplier State:</label>
                                                    <input type="text" name="Supp_state_cd" value={stateName} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '2px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} disabled={formMode === 'view'} />
                                                </div>
                                            
                                                <h5>INVOICE TO -</h5>
                                                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '25px', color: 'darkblue' }}>Company Name:</label>
                                                    eMedha Technologies
                                                </div>
                                            </div>

                                            <div>
                                                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '86px', color: 'darkblue' }}>PO NO:</label>

                                                    <input value={PO_no} maxLength={20} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '2px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />

                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '88px', color: 'darkblue' }}>P O Dt:</label>
                                                    <input name="PO_Dt" value={formatDateToDateInput(poData.PO_HDR.PO_Dt)} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '2px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} disabled={formMode === 'view'} />
                                                </div>

                                                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '28px', color: 'darkblue' }}>Payment Terms:</label>
                                                    <input type="text" name="Pay_terms" value={poData.PO_HDR.Pay_terms} maxLength={20} pattern="[A-Za-z0-9]+" style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '2px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} disabled={formMode === 'view'} />
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '32px', color: 'darkblue' }}>Delivery Terms:</label>
                                                    <input type="text" name="Deli_terms" value={poData.PO_HDR.Deli_terms} maxLength={20} pattern="[A-Za-z0-9]+" style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '2px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} disabled={formMode === 'view'} />
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '57px', color: 'darkblue' }}>Delivery Dt:</label>
                                                    <input value={formatDateToDateInput(poData.PO_HDR.Deli_dt)} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '2px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} disabled={formMode === 'view'} />
                                                </div>
                                            </div>

                                            <div>

                                               

                                            </div>
                                        </div>


                                        <div className="table-responsive" style={{ overflowY: 'auto', maxHeight: '150px' }}>
                                            <div>
                                                <table className="table" style={{ minWidth: '100%', borderCollapse: 'collapse', border: '1px solid black' }}>
                                                    <thead>
                                                        <tr>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}></th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}></th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}></th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}></th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}></th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}></th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}></th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}></th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}></th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}></th>

                                                            

                                                            <th colSpan="2" className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>SGST</th>

                                                            <th colSpan="2" className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>CGST</th>
                                                            <th colSpan="2" className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>IGST</th>

                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}></th>
                                                        </tr>

                                                        <tr>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>Sl</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>Item Code</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>Item Description</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>UOM</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>HSN CODE</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>Indent Qty</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>PO Qty</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>Item Rate</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>Disc %</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>Taxable amt</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>%</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>Amt</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>%</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>Amt</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>%</th>
                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>Amt</th>

                                                            <th className="text-center" style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }}>Total Amt</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {poData.PO_DTL.map((indent, index) => (
                                                            <tr key={index}>
                                                                <td style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{index + 1}</td>
                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.itemCd}</td>
                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.itemDesc}</td>
                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.UOM}</td>
                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.Hsn_code}</td>
                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.qty}</td>
                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.PO_qty}</td>
                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.Item_rate}</td>
                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.Disc_per}</td>
                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.Taxable_amt}</td>

                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.Sgst_per}</td>
                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.Sgst_amt}</td>

                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.Cgst_per}</td>
                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.Cgst_amt}</td>

                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.Igst_per}</td>
                                                                <td style={{ minWidth: '70px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.Igst_amt}</td>

                                                                <td style={{ minWidth: '90px', border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.Net_amt}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        <>

                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginRight: '10px' }}>

                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '6px', width: '250px', marginBottom: '20px' }}>

                                                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                        <label style={{ width: '140px', textAlign: 'left', color: 'darkblue' }}><strong>Totals:</strong></label>
                                                        {(poData.PO_HDR.Total_amt - poData.PO_HDR.Freight_amt - poData.PO_HDR.Insurance_amt - poData.PO_HDR.Oth_amt).toFixed(2)}
                                                    </div>
                                                </div>

                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '6px', width: '250px' }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                        <label style={{ width: '140px', textAlign: 'left', color: 'darkblue' }}>Freight amt:</label>
                                                        <input name="Freight_amt" value={poData.PO_HDR.Freight_amt}

                                                            style={{ textAlign: 'right', border: 'none', borderLeft: '2px solid #D1D5DB', minWidth: '80px', outline: 'none', backgroundColor: 'transparent' }}
                                                            maxLength={10} pattern="[A-Za-z0-9]+" />
                                                    </div>

                                                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                        <label style={{ width: '140px', textAlign: 'left', color: 'darkblue' }}>
                                                            Insurace amt:</label>
                                                        <input type="text" name="Insurance_amt"
                                                            value={poData.PO_HDR.Insurance_amt}
                                                            style={{ textAlign: 'right', border: 'none', borderLeft: '2px solid #D1D5DB', minWidth: '80px', outline: 'none', backgroundColor: 'transparent' }} maxLength={10} pattern="[A-Za-z0-9]+" />
                                                    </div>

                                                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                        <label style={{ width: '140px', textAlign: 'left', color: 'darkblue' }}>Other amt:</label>
                                                        <input type="text" name="Oth_amt" value={poData.PO_HDR.Oth_amt}
                                                            style={{ textAlign: 'right', border: 'none', borderLeft: '2px solid #D1D5DB', minWidth: '80px', outline: 'none', backgroundColor: 'transparent' }} maxLength={10} pattern="[A-Za-z0-9]+" />
                                                    </div>

                                                </div>

                                            </div>
                                            <Row>
                                                <Col md={8}>
                                                    <div style={{ display: 'flex', textAlign: 'right', marginTop: '10px', color: 'black' }}>

                                                        <strong>Amount in Words: </strong>  <span style={{ textTransform: 'uppercase', borderBottom: '1px solid black', width: '300px', display: 'inline-block' }}>

                                                            {amountInWords}
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div style={{ textAlign: 'right', justifyContent: 'space-between' }}>
                                                        <label style={{ color: 'darkblue' }}>Grand Total:</label>
                                                        <input type="text" name="Total_amt" value={poData.PO_HDR.Total_amt || 0}
                                                            style={{ textAlign: 'right', border: 'none', minWidth: '70px', outline: 'none', backgroundColor: 'transparent' }} />
                                                    </div>
                                                </Col>

                                            </Row>

                                        </>
                                    </div>
                                )} */
}
